import { createStyles } from '@mantine/core'

export default createStyles((theme: any) => ({
  mainGrid: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: '100vw',
    minHeight: '100vh',
    backgroundColor: '#000000',
  },
  innerDiv: {
    maxWidth: '1200px',
    marginTop: '75px',
    marginLeft: '20px',
    marginRight: '20px',
    [theme.fn.smallerThan(992)]: {
      marginTop: '50px',
    },
  },
  h1Tag: { 
    marginBottom: '0px',
    marginTop: '0px',
    fontSize: '40px',
    [theme.fn.smallerThan(600)]: {
      fontSize: '38px',
    },
    [theme.fn.smallerThan(520)]: {
      fontSize: '37px',
    },
    [theme.fn.smallerThan(500)]: {
      fontSize: '35px',
    },
    [theme.fn.smallerThan(480)]: {
      fontSize: '33px',
    },
    [theme.fn.smallerThan(431)]: {
      fontSize: '30px',
    },
    [theme.fn.smallerThan(410)]: {
      fontSize: '28px',
    },
    [theme.fn.smallerThan(390)]: {
      fontSize: '26px',
    },
    [theme.fn.smallerThan(350)]: {
      fontSize: '23px',
    },
    [theme.fn.smallerThan(331)]: {
      fontSize: '19px',
    },
    [theme.fn.smallerThan(310)]: {
      fontSize: '18px',
    },
  },
  threeDotDivisorBottomOfArticle: {
    border: 'none',
    height: '.7em',
    paddingTop: '70px',
    paddingBottom: '0px !important',
    marginBottom: '40px !important',
    background: `radial-gradient(circle at center, #ffffff 0.2em, transparent 0.2em) 0 50%,
              radial-gradient(circle at center, #ffffff 0.2em, transparent 0.2em) 50% 50%,
              radial-gradient(circle at center, #ffffff 0.2em, transparent 0.2em) 100% 50%`,
    backgroundSize: '33.33% 100%',
    backgroundRepeat: 'no-repeat',
    margin: '1em 0;',
  },
  h2Tag: {
    marginBottom: '0px',
    marginTop: '0px',
    fontSize: '35px',
    color: '#ff8c00 !important',
    [theme.fn.smallerThan(520)]: {
      fontSize: '25px',
    },
    [theme.fn.smallerThan(431)]: {
      fontSize: '20px',
    },
    [theme.fn.smallerThan(331)]: {
      fontSize: '18px',
    },
  },
  pJoinThousands: {
    marginTop: '0px',
  },
  standardText: {
    fontFamily: 'Arial, sans-serif',
    fontWeight: 'bold',
    color: '#ffffff',
  },
  ulArticles: {
    display: 'flex',
    flexDirection: 'column',
    listStyle: 'none',
    padding: '0px',
    margin: '0px',
    height: '100%',
  },
  liArticle: {
    flexGrow: 1,
    height: '100%',
    marginBottom: '20px',
    fontSize: '21px',
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    flexDirection: 'column',
    zIndex: 300,
    [theme.fn.smallerThan(992)]: {
      fontSize: '17px',
    },
  },
  imgDrink: {
    marginBottom: '15px',
  },
  articleLink: {
    color: '#b476eeff !important',
    cursor: 'pointer',
    display: 'inline-block',
    zIndex: 300,
    '&:hover': {
      opacity: 0.75,
    },
  },
  musicLabel: {
    fontSize: '25px',
    fontWeight: 'bold',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.85,
    },
  },
  musicLabelNotHoverable: {
    fontSize: '25px',
    fontWeight: 'bold',
    cursor: 'default',
  },
  asianTextBlock: {
    whiteSpace: 'nowrap',
  },
}))
